import { Seo } from "../components/Seo";
import { site } from "../config/site";

export function TermsPage() {
  const policy = site.policies.terms.trim();

  return (
    <main id="main" className="page">
      <Seo
        title="Terms"
        description="Terms of use for Beautiful Jewellery."
        path="/terms"
      />
      <p className="kicker">Terms</p>
      <h1>Terms</h1>
      {policy ? (
        <div className="info-card padded-card policy-copy section">{policy}</div>
      ) : (
        <p className="lede">We are preparing this page.</p>
      )}
    </main>
  );
}
